module.exports = new __parcel__URL__("wac.92a80da2.svg").toString();